export class Parts {
    constructor() {
        this.parts = new Map();
        this._size = 0;
    }
    get length() {
        return this.parts.size;
    }
    add(part) {
        if (this.parts.get(part.id)) {
            throw new Error(`Part ${part.id} already exist`);
        }
        this.parts.set(part.id, part);
        this._size = this._size + ((part === null || part === void 0 ? void 0 : part.lengthToRead) ? part.lengthToRead : 0);
        return this;
    }
    get size() {
        return this._size;
    }
    get sizeUploaded() {
        return this.list().reduce((prev, curr) => prev + curr.uploadedBytes, 0);
    }
    has(id) {
        return this.parts.has(id);
    }
    get(id) {
        if (this.has(id)) {
            return this.parts.get(id);
        }
        throw new Error(`Part ${id} does not exist`);
    }
    remove(id) {
        const part = this.get(id);
        this.parts.delete(id);
        if (part.lengthToRead) {
            this._size -= part.lengthToRead;
        }
        return part;
    }
    list() {
        const parts = [];
        this.parts.forEach(value => {
            parts.push(value);
        });
        return parts;
    }
    slice(start = 0, end = this.length - 1) {
        const parts = new Parts();
        this.list().slice(start, end).forEach(part => parts.add(part));
        return parts;
    }
    forEach(callback) {
        const parts = this.list();
        for (let index = 0; index < parts.length; index++) {
            callback(parts[index], index, this.parts);
        }
    }
    map(callback) {
        const collection = [];
        const parts = this.list();
        for (let index = 0; index < parts.length; index++) {
            collection.push(callback(parts[index], index, this.parts));
        }
        return collection;
    }
}
